/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Swift_Bold_Crane_FlyInputs */

const en_swift_bold_crane_fly = /** @type {(inputs: Swift_Bold_Crane_FlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Add Round`)
};

const de_swift_bold_crane_fly = /** @type {(inputs: Swift_Bold_Crane_FlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Runde hinzufügen`)
};

/**
* | output |
* | --- |
* | "Add Round" |
*
* @param {Swift_Bold_Crane_FlyInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const swift_bold_crane_fly = /** @type {((inputs?: Swift_Bold_Crane_FlyInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Swift_Bold_Crane_FlyInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_swift_bold_crane_fly(inputs)
	return de_swift_bold_crane_fly(inputs)
});